import "./main.css";
import AppRouter from "./router";
import { Provider } from "react-redux";
import { store } from "./store";
import { useEffect } from "react";

function Main() {
  useEffect(() => {
    console.log(process.env.NODE_ENV);
  }, []);
  return (
    <Provider store={store}>
      <div className="App">
        <AppRouter />
      </div>
    </Provider>
  );
}

export default Main;
